import { Icons } from "@/components/ui";
import { TrayTooltip } from "@/desktop/tray-panel-controls";
import { useThemeCycle } from "@/hooks/use-theme-cycle";
import { useT } from "@/i18n";
import { layoutMessages } from "@/i18n/messages/layout";
import { panelsHeaderMessages } from "@/i18n/messages/panels-header";
import { useDesktopMode } from "@/stores/desktop-mode-store";
import { WallChromeButton } from "./wall-chrome-button";

/** Switches dark ↔ light, as the rail's theme button does. */
export function WallThemeButton() {
  const t = useT(panelsHeaderMessages);
  const { active, cycle } = useThemeCycle();
  const ThemeIcon = active.icon;
  return (
    <WallChromeButton
      size="icon"
      className="group relative shrink-0"
      aria-label={t("themeLabel", { theme: active.label })}
      aria-describedby="wall-theme-tooltip"
      onClick={cycle}
      data-testid="wall-theme"
    >
      <ThemeIcon className="h-4 w-4" aria-hidden="true" />
      <TrayTooltip id="wall-theme-tooltip" label={active.label} />
    </WallChromeButton>
  );
}

/** Closes the Workspace (desktop only); the tooltip names its shortcut. */
export function WallCloseButton() {
  const t = useT(layoutMessages);
  return (
    <WallChromeButton
      size="icon"
      className="group relative shrink-0"
      aria-label={t("closeWorkspace")}
      aria-describedby="wall-close-workspace-tooltip"
      onClick={() => useDesktopMode.getState().closeWorkspace()}
      data-testid="wall-close-workspace"
    >
      <Icons.X className="h-4 w-4" aria-hidden="true" />
      <TrayTooltip
        id="wall-close-workspace-tooltip"
        label={t("closeWorkspace")}
        shortcut="shortcut-toggle-workspace"
      />
    </WallChromeButton>
  );
}
